import React from "react"
import { useLocation, useNavigate, Link } from "react-router-dom"
import ROUTES from "../../components/routesConstants"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Button } from "primereact/button"
import { BreadCrumb } from "primereact/breadcrumb"
const home = {
  label: (
    <Link to={ROUTES.Home} style={{ textDecoration: "none", color: "inherit" }}>
      Home
    </Link>
  ),
}
const breadcrumbItems = [{ label: "Saved Order" }]

export default function SaveOder() {
  const location = useLocation()
  const orderSelected = location.state?.orders
  const navigate = useNavigate()

  return (
    <div>
      <BreadCrumb className="-mt-2" model={breadcrumbItems} home={home} />
      <div className=" flex flex-column   my-6 gap-2">
        <h2 className="ml-4">Your Order has been Saved</h2>
        <h4 className="ml-4">But you can still edit your order</h4>
        {orderSelected && orderSelected.length > 0 ? (
          <h4 className="ml-4">Check the results below</h4>
        ) : (
          ""
        )}
      </div>
      <hr />

      <section>
        {orderSelected && orderSelected.length > 0 ? (
          <div className="my-4 p-0">
            <DataTable
              className=" mx-4"
              value={orderSelected}
              paginator
              rows={100}
            >
              <Column
                className="w-30rem text-center"
                field="order_results_id"
                header="Result Id"
              />
              <Column
                className="w-30rem"
                field="din"
                header="DIN"
                sortable
                filter
              />
              <Column
                className="w-30rem text-center"
                field="din_profile"
                header="Profile"
                sortable
                filter
              />
              <Column
                className="w-30rem text-center"
                field="aborh"
                header="ABO Rh"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="x"
                header="Safety Score"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="y"
                header="Replacement Score"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="count_ag_cceekk"
                header="CcEeKk"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="count_ag_duffy"
                header="Duffy"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="count_ag_kidd"
                header="Kidd"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="count_ag_mns"
                header="MNS"
                sortable
              />
              <Column
                className="w-30rem text-center"
                field="count_ag_extended"
                header="Extended"
                sortable
              />
            </DataTable>
          </div>
        ) : (
          <p className="mx-4">
            No order results available, please check if you selected a blood
            unit.
          </p>
        )}
      </section>
      <div className="flex justify-content-end my-4 mr-4">
        <Button
          className="p-button-primary"
          label="Back to Home"
          onClick={() => navigate(ROUTES.Home)}
        />
      </div>
    </div>
  )
}
